import React from 'react';
import Line from './components/line/Line';
import styles from './Step.module.scss';
import Label from './components/label';
import StateIcon from './components/stateIcon';

interface ISteps {
  step?: number;
  activeStep?: number;
  label?: string;
  onClick?: (step: number) => void;
}


const Step = (props: Partial<ISteps>) => {
  return (
    <div className={styles.Step} onClick={() => props.onClick(props.step)}>
      <Line {...props}/>
      <div className={styles.labelContainer}>
        <StateIcon {...props}/>
        <Label {...props}/>
      </div>
    </div>
  );
};

Step.defaultProps = {
  label: "",
  active: false,
  onClick: () => {
  },
};

export default React.memo(Step);
